import {Injectable} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {BranchDBService} from '../@db/branch-db.service';
import 'rxjs-compat/add/operator/switchMap';
import {PersistenceService} from 'angular-persistence';

@Injectable()
export class ContactUsService {
  form = this.fb.group({
    branch: '',
    name: '',
    to_email: ['', Validators.email],
    msg_subject: '',
    msg_body: '',
  });

  activeBranch = this.form.get('branch').valueChanges
    .startWith(null)
    .map(() => this.form.get('branch').value)
    .switchMap(pk => {
      if (pk) {
        return this.branchDb.get(pk);
      } else {
        return this.branchDb.getDefaultForMap();
      }
    })
    .shareReplay(1);

  constructor(private fb: FormBuilder,
              private branchDb: BranchDBService,
              private persistence: PersistenceService) {
    const defaultBranch = this.persistence.get('branch');
    this.branchDb.list.filter(b => defaultBranch && b.alias === defaultBranch)
      .subscribe(branch => this.form.get('branch').setValue(branch.pk));
  }
}
